var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lottie-container"},[_c('vue-lottie-player',{attrs:{"autoplay":"","loop":"","mode":"normal","path":"https://assets2.lottiefiles.com/packages/lf20_msa6voq8.json","width":"85px","height":"82px","name":"mail"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }